import { render } from "./GroupModal.vue?vue&type=template&id=976b47d4"
import script from "./GroupModal.vue?vue&type=script&lang=js"
export * from "./GroupModal.vue?vue&type=script&lang=js"

import "./GroupModal.vue?vue&type=style&index=0&id=976b47d4&lang=css"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__